/**
 * SETTINGS STORE
 */
import { sidebarBackgroundImages, sidebarFilters, routerAnimations, themes, headerFilters } from "Application/data/settings.data";

import api from "Api";

import languages from "Lang";
import { ChartConfig } from "Constants/chart-config";

const state = {
    darkMode: false, // dark mode
    collapseSidebar: false, // mini sidebar
    rtlLayout: false, // rtl layout
    backgroundImage: false, // enable sidebar background image
    horizontalLayoutSidebar: false, // horizontal layout sidebar
    languages, // languages
    selectedLocale: languages["en"], // selected locale
    sidebarBackgroundImages, // sidebar backgorund images
    selectedSidebarBgImage: sidebarBackgroundImages[0], // selected sidebar background image
    sidebarFilters, // sidebar filters
    sidebarSelectedFilter: sidebarFilters[0], // selected sidebar filter
    routerAnimations, // router animations
    selectedRouterAnimation: routerAnimations[1], // selected router animation
    themes, // themes
    selectedTheme: themes[0], // selected theme
    headerFilters, // header filters
    activeHeaderFilter: headerFilters[6], // selected header filter
    mobileSearchForm: false, // is mobile search form open
    loader: false, // controls global loader
    modal_loader: false, // controls modal loader
    special_loader: false, // controls special loader
    sidebar_loader: false, // controls sidebar loader
    login_loader: false, // controls spinner on login button
    current_tour: false, // sets which tour to display
    ChartConfig: ChartConfig, // sets chart config from constants file
    page: {},
    filter_menu: false,
    sessions_filter: {
        page_size: 0,
        page_num: 1,
    },
    login_attempts_filter: {
        search: "",
        login: "",
        status: "fail",
        page_size: 0,
        page_num: 1,
    },
    shipping_unit_options: null,
    shipping_carrier: null,
    shipping_carriers: JSON.parse(localStorage.getItem("shipping_carriers")) || null,
    shipping_carriers_filter: {
        search: "",
        page_size: 0,
        page_num: 1,
    },
    invoice_status_options: null,
    machine_category_options: null,
    global_snackbar: false,
    dashboard_arranging_widgets: true,
    rfq_status_options: null,
    quote_status_options: null,
    purchase_order_status_options: null,
    order_status_options: null,
    fe_invoice_status_options: null,
    quote_request_status_options: null,
};

// getters
const getters = {
    darkMode: (state) => {
        return state.darkMode;
    },
    collapseSidebar: (state) => {
        return state.collapseSidebar;
    },
    boxLayout: (state) => {
        return state.boxLayout;
    },
    rtlLayout: (state) => {
        return state.rtlLayout;
    },
    backgroundImage: (state) => {
        return state.backgroundImage;
    },
    selectedLocale: (state) => {
        return state.selectedLocale;
    },
    languages: (state) => {
        return state.languages;
    },
    sidebarBackgroundImages: (state) => {
        return state.sidebarBackgroundImages;
    },
    selectedSidebarBgImage: (state) => {
        return state.selectedSidebarBgImage;
    },
    sidebarFilters: (state) => {
        return state.sidebarFilters;
    },
    sidebarSelectedFilter: (state) => {
        return state.sidebarSelectedFilter;
    },
    selectedRouterAnimation: (state) => {
        return state.selectedRouterAnimation;
    },
    routerAnimations: (state) => {
        return state.routerAnimations;
    },
    themes: (state) => {
        return state.themes;
    },
    selectedTheme: (state) => {
        return state.selectedTheme;
    },
    headerFilters: (state) => {
        return state.headerFilters;
    },
    activeHeaderFilter: (state) => {
        return state.activeHeaderFilter;
    },
    horizontalLayoutSidebar: (state) => {
        return state.horizontalLayoutSidebar;
    },
    mobileSearchForm: (state) => {
        return state.mobileSearchForm;
    },
    loader: (state) => {
        return state.loader;
    },
    modal_loader: (state) => {
        return state.modal_loader;
    },
    special_loader: (state) => {
        return state.special_loader;
    },
    sidebar_loader: (state) => {
        return state.sidebar_loader;
    },
    current_tour: (state) => {
        return state.current_tour;
    },
    ChartConfig: (state) => {
        return state.ChartConfig;
    },
    filter_menu: (state) => {
        return state.filter_menu;
    },
    sessions_filter: (state) => {
        return state.sessions_filter;
    },
    login_attempts_filter: (state) => {
        return state.login_attempts_filter;
    },
};

// actions
const actions = {
    async fetchSetting({ rootState, commit }, payload) {
        try {
            let body = "";

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (response.data && response.data.page) {
                    commit("commitSetting", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                let split_state = payload.stateProperty ? (payload.stateProperty || "").split("|") || [] : [];
                let split_data = payload.dataProperty ? (payload.dataProperty || "").split("|") || [] : [];
                split_state.forEach((ss, i) => {
                    let sd = split_data[i] || ss;
                    if (payload.commit) {
                        commit("commitSetting", {
                            property: ss,
                            with: _.get(response.data, sd),
                        });
                        if (payload.localStorage) {
                            localStorage.setItem(ss, JSON.stringify(_.get(response.data, sd)));
                        }
                    }
                    if (payload.mutate) {
                        commit("mutateSetting", {
                            property: ss,
                            with: _.get(response.data, sd),
                            method: payload.method,
                            id: payload.id,
                            pk: payload.pk,
                        });
                    }
                });

                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
    darkModeHandler(context) {
        context.commit("darkModeHandler");
    },
    collapseSidebar(context) {
        context.commit("collapseSidebarHandler");
    },
    boxLayout(context) {
        context.commit("boxLayoutHandler");
    },
    rtlLayout(context) {
        context.commit("rtlLayoutHandler");
    },
    backgroundImage(context) {
        context.commit("sidebarBgImageHandler");
    },
    changeLanguage(context, payload) {
        context.commit("changeLanguageHandler", payload);
    },
    changeBackgroundImage(context, payload) {
        context.commit("changeBackgroundImageHandler", payload);
    },
    changeSidebarFilter(context, payload) {
        context.commit("changeSidebarFilterHandler", payload);
    },
    changeRouterAnimation(context, payload) {
        context.commit("changeRouterAnimationHandler", payload);
    },
    changeTheme(context, payload) {
        context.commit("changeThemeHandler", payload);
    },
    changeHeaderFilter(context, payload) {
        context.commit("changeHeaderFilterHandler", payload);
    },
    setMiniSidebarLayout(context, payload) {
        context.commit("setMiniSidebarLayoutHandler", payload);
    },
    toggleHorizontalLayoutSidebar(context, payload) {
        context.commit("toggleHorizontalLayoutSidebarHandler", payload);
    },
    toggleSearchForm(context) {
        context.commit("toggleSearchFormHandler");
    },
    toggleModalLoader(state, value) {
        if (typeof value !== "undefined" && value !== null) {
            if (value) {
                state.commit("toggleModalLoader", value);
            } else {
                setTimeout(() => {
                    state.commit("toggleModalLoader", value);
                }, 300); // a 250ms animation is used to close dialogs, turn off modal loader after animation ends
            }
        }
    },
};

// mutations
const mutations = {
    commitSetting(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    mutateSetting(state, payload) {
        if (payload.method == "post" && payload.with) {
            let property = _.get(state, payload.property);
            if (property == null) _.set(state, payload.property, []);
            state[payload.property].push(payload.with);
        } else if (payload.method == "patch" && payload.property && payload.with && payload.pk) {
            let curr_item = state[payload.property][state[payload.property].findIndex((obj) => obj[payload.pk] == payload.with[payload.pk])];
            for (const key in payload.with) if (key in curr_item) curr_item[key] = payload.with[key];
        } else if (payload.method == "delete" && payload.property && payload.pk && payload.id) {
            state[payload.property].splice(
                state[payload.property].findIndex((obj) => obj[payload.pk] == payload.id),
                1
            );
        }
    },
    darkModeHandler(state) {
        state.darkMode = !state.darkMode;
    },
    collapseSidebarHandler(state) {
        state.collapseSidebar = !state.collapseSidebar;
    },
    boxLayoutHandler(state) {
        state.boxLayout = !state.boxLayout;
    },
    rtlLayoutHandler(state) {
        state.rtlLayout = !state.rtlLayout;
    },
    sidebarBgImageHandler(state) {
        state.backgroundImage = !state.backgroundImage;
    },
    changeLanguageHandler(state, language) {
        state.selectedLocale = language;
        if (language.locale === "he" || language.locale === "ar") {
            state.rtlLayout = true;
        } else {
            state.rtlLayout = false;
        }
    },
    changeBackgroundImageHandler(state, image) {
        state.selectedSidebarBgImage = image;
    },
    changeSidebarFilterHandler(state, filter) {
        state.sidebarSelectedFilter = filter;
    },
    changeRouterAnimationHandler(state, animation) {
        state.selectedRouterAnimation = animation;
    },
    changeThemeHandler(state, theme) {
        state.selectedTheme = theme;
    },
    changeHeaderFilterHandler(state, filter) {
        state.activeHeaderFilter = filter;
    },
    toggleFilterMenu(state, filter) {
        state.filter_menu = filter;
    },
    setMiniSidebarLayoutHandler(state, isSet) {
        state.collapseSidebar = isSet;
    },
    toggleHorizontalLayoutSidebarHandler(state, value) {
        state.horizontalLayoutSidebar = value;
    },
    toggleSearchFormHandler(state) {
        state.mobileSearchForm = !state.mobileSearchForm;
    },
    toggleLoader(state, value) {
        if (typeof value !== "undefined" && value !== null) {
            state.loader = value;
        }
    },
    toggleModalLoader(state, value) {
        state.modal_loader = value;
    },
    toggleSpecialLoader(state, value) {
        if (typeof value !== "undefined" && value !== null) {
            state.special_loader = value;
        }
    },
    toggleSidebarLoader(state, value) {
        if (typeof value !== "undefined" && value !== null) {
            state.sidebar_loader = value;
        }
    },
    toggleLoginLoader(state, value) {
        if (typeof value !== "undefined" && value !== null) {
            state.login_loader = value;
        }
    },
    changeTour(state, value) {
        state.current_tour = value;
        console.log(value);
    },
    toggleGlobalSnackbar(state, value = null) {
        state.global_snackbar = value != null ? value : !state.global_snackbar;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
